export enum ACHAccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
}
